<template>
  <div class="page flex-v noselect" v-if="loaded" @click="showList = 0;showSign=false;">
    <HeaderNav :posNavs="posNavs" :topLevel="true" ref="headRef"/>
    <div :class="['container flex', getMenuWay ? 'hasMenu' : '']">
      <Sider :showLogo="false">
        <CommNav :navList="navList" :isShowWork="isShowAssign" :actId="selectItem.id" @itemClick="navItemClick" />
      </Sider>
      <div class="layout-right flex-v">
        <div class="main flex-v" :class="['main-'+selectItem.id]">
          <div class="tab-con">
            <div class="tab-item" v-if="selectItem.id==1">
              <div class="play-box flex-v" :style="bgStyles" :class="{'play-box-center' : getIsFlexCenter}">
                <AudioManager @onPartItemClick="onPartItemClick" @onRowClick="onRowClickHandle" ref="article_manage" type="1" :options="audioTypes.article" @openReport="openReport">
                  <Flower :showSign="true" :disabled="audioTypes[key].canClickRow || audioStates[key].playMode!='auto'"></Flower>
                </AudioManager>
                <div class="teacher" v-if="info.article?.tearcherName">
                  <i class="icon icon-teacher"></i>
                  <span>{{info.article.tearcherName}}</span>
                </div>
              </div>
              <div v-if="audioTypes.article.isWrite" class="play-filter"></div>
              <Annotation :courseId="id + ''" :status="showSign" ref="annotRef" @change="showSign = false" @onPlay="dishPlay"/>
            </div>
            <div class="tab-item" v-if="selectItem.id==2">
              <div class="play-box flex-v" :class="{'play-box-center' : getIsFlexCenter}">
                <AudioManager ref="guidance_manage" type="2" :options="audioTypes.guidance">
                  <div class="blackboard">
                    <div class="title">朗读指导</div>
                    <div class="txts">
                      <div class="txt" v-if="!guidance.hasTxt" v-html='guidance.txt'></div>
                      <div class="book-words" v-else :class="['book-words-'+ guidance.wordPageStyle]">
                        <div class="word-row">
                          <WordRow :row="guidance.curRow" />
                        </div>
                      </div>
                    </div>
                  </div>
                </AudioManager>
              </div>
            </div>
            <div class="tab-item words-box" v-if="selectItem.id==3">
              <ScrollBar ref="scrollbar" class="scroll-view">
                <div id="top" class="word-wrap">
                  <div class="word-box-item" v-if="type.list && type.list.length>0" v-for="(type,i) in wordTypes" :key="i">
                    <div class="word-box">
                      <div class="title">
                        <i class="icon icon-word"></i>
                        <span>{{type.name}}</span>
                      </div>
                      <div class="word-content" v-if="type.type==1">
                        <div class="word-list clearfix">
                          <div :id="'word_'+item.id" class="word btn-tip btn-tip-word" :class="{'actived' : curWordState.id==item.id}" v-if="item.wordItem" v-for="(item,index) in type.list" @click.stop="playClickWord(item,index)" @dblclick.stop="showWordGif(item,index,0)" :key="index">
                            <div class="piny">
                              <i class="icon icon-hear"></i>
                              <span>{{item.wordItem.py}}</span>
                            </div>
                            <div class="piny-b"></div>
                            <div class="zh" :class="{'is-write':curWordState.isWrite && item.isWrite }">{{ curWordState.isWrite && item.isWrite ? '' : item.wordItem.zh}}</div>
                            <div class="tip" v-if="item.gifUrl && item.gifUrl.length">双击查看笔顺</div>
                          </div>
                        </div>
                      </div>
                      <div class="word-content" v-else>
                        <div class="word-list speech-list">
                          <div class="word btn-tip-word" :id="'word_'+item.id" :class="{'actived' : curWordState.id==item.id}" v-for="(item,index) in type.list" :key="index">
                            <div class="word-item" @click.stop="playClickWord(item, index)" @dblclick.stop="showWordGif(item, index,n)" :class="{'actived' : curWordState.id==item.id}" v-for="(w,n) in item.list" :key="n">
                              <div class="piny" v-if="w.py">
                                <i class="icon icon-hear" v-if="!n"></i>{{w.py}}
                              </div>
                              <div class="piny-b"></div>
                              <div class="zh" :class="{'is-write': curWordState.isWrite && item.isWrite }">{{ curWordState.isWrite && item.isWrite ? '' : w.zh}}</div>
                              <div class="tip" v-if="item.gifUrl && item.gifUrl.length">双击查看笔顺</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ScrollBar>
              <AudioManager ref="word_manage" type="3" :options="wordAudioOptions" />
              <div class="right">
                <RightNav :selected="selectedWordTypeItem" @itemClick="rightNavItemClick" title="板块选择" :navList="wordNavList" />
                <div class="rm-menu">
                  <Flower></Flower>
                  <button class="btn btn-hands"></button>
                </div>
              </div>
            </div>
            <div class="tab-item" v-if="selectItem.id==4">
              <ScrollBar ref="scrollbar">
                <div class="target-box">
                  <div class="teach-target" :style="getMinHeightStyle">
                    <h2>本课朗读教学目标</h2>
                    <div class="content" v-if="info.teachingTarget" v-html="info.teachingTarget.contents">
                    </div>
                  </div>
                </div>
              </ScrollBar>
            </div>
            <div class="tab-item flex-v flex-center" v-if="selectItem.id==5">
              <div class="work-box">
                <div class="top">
                  <div class="top-txt">
                    <h2>朗朗书声</h2>
                    <p>小学语文同步朗读指导</p>
                    <div class="stat">
                      全国<em>
                        <CountUp v-if="getStatInfo.teacherCnt" :endnum="getStatInfo.teacherCnt" /></em> 名教师 <em>
                        <CountUp v-if="getStatInfo.studentCnt" :endnum="getStatInfo.studentCnt" /></em> 名学生，正在小程序中布置/完成朗读作业
                    </div>
                  </div>
                  <div class="phone"></div>
                </div>
                <ul>
                  <!-- <li>
                    <div class="img-box">
                      <img src="~images/qrcode1.jpg">
                    </div>
                    <div class="txt">微信公众号</div>
                  </li> -->
                  <li>
                    <div class="img-box">
                      <img v-if="isOrga" :src="codeImg" />
                      <img v-else src="~images/qrcode.jpg">
                    </div>
                    <div class="txt">微信小程序</div>
                  </li>
                </ul>
                <div class="acount-tip">使用教学平台账号、密码可直接登录小程序</div>
              </div>
            </div>
            <!-- 布置练习 -->
            <!-- <AssignWork v-if="isShowAssign" :workTit="info.name" :courseId="id" @sureAssign="sureAssign"></AssignWork> -->
            <!-- 练习报告 -->
            <template v-if="selectItem.id === 7">
              <!-- 详情 -->
              <!-- <ReportDetails v-if="showReportDetail" :homeworkId="homeworkId"></ReportDetails> -->
              <Details v-if="showReportDetail" :homeworkId="homeworkId" :isCousePage="true"></Details>
              <!-- 列表 -->
              <ExamList @checkDetails="checkDetails" :isCousePage="true" v-else />
              <!-- <ReportList v-else @checkDetails="checkDetails" :classesId="classesId" @goAssign="isShowAssign = true"></ReportList> -->
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="layout-footer" v-if="selectItem.showFooter">
      <div class="course-info">
        <div class="course-img">
          <img :src="info.thumbnailUrl">
        </div>
        <div class="bar btn-tip">
          <ProgressBar @touchend="touchend" :currentTime="currentTime" :duration="duration">
            <div class="course-name line1">{{info.halfName}}</div>
          </ProgressBar>
          <div class="tip">点击、拖动时间轴播放</div>
        </div>
        <div class="list btn-tip" @click.stop="openList">
          <i class="icon icon-list"></i>
          <span>目录</span>
          <div class="tip">选择其他章节</div>
        </div>
      </div>
      <div class="play-btns">
        <!-- <a class="btn btn-mode btn-mode-pre"></a> -->
        <a class="btn btn-pre btn-tip" :class="{'disabled': disableOpts.preDisabled}" @click.stop="switchCourse(1)">
          <div class="tip">播放上一章</div>
        </a>
        <a class="btn btn-play btn-tip" @click.stop="togglePlay()">
          <i class="icon icon-play" :class="{'icon-pause': audioStates[key].isPlay}"></i>
          <div class="tip">播放/暂停</div>
        </a>
        <a class="btn btn-next btn-tip" :class="{'disabled': disableOpts.nextDisabled}" @click.stop="switchCourse(2)">
          <div class="tip">播放下一章</div>
        </a>
        <a class="btn btn-mode btn-tip" :class="{'hid' : key =='word' || (key=='article' && !showLoop)}" @click.stop="setLoopMode">
          <i class="icon iconfont " :class="['danzhangbofang','danpianxunhuan','shunxubofang'][loopMode-1]"></i>
          <span>{{ loopModeTxt }}</span>
        </a>
        <!-- <Rate v-show="!(key =='word' || (key=='article' && !showLoop))"/> -->
      </div>
      <div class="right-btns" v-if="key=='article'">
        <a class="btn btn-def btn-clickred btn-tip" @click.stop="openRecord">
          <i class="iconfont ai"></i>
          <span>全文练习</span>
        </a>
        <a v-if="audioTypes[key] && isHasTime" :class="{'btn-act': tapRead.status}" class="btn btn-def btn-clickred btn-tip" @click.stop="changeMode(true)">
          <i class="iconfont ai"></i>
          <span>点读练习</span>
          <!-- <div class="tip">开启点读练习功能，点击课文中的某句收听示范朗读</div> -->
           <div class="el-drawer__wrapper" v-show="tapRead.status" @click.stop="changeMode(false)">
          </div>
            <ul class="select" @click.stop v-show="tapRead.status">
              <li><el-switch v-model="tapRead.isAuto" active-color="#57AE59" style="margin-right: 5px;" ></el-switch>音频自动播放</li>
              <li :class="tapRead.key === 'ai' && 'on'" @click="onClickMode('ai')">AI 点读练习模式</li>
              <li :class="tapRead.key === 'common' && 'on'" @click="onClickMode('common')">普通点读练习模式</li>
            </ul>
        </a>
        <a v-if="audioStates[key] && isHasTime" :class="{'btn-act': audioStates[key].playMode!='auto'}" class="btn btn-def btn-follow btn-tip" @click.stop="articleState(1)">
          <i class="icon"></i>
          <span>跟读练习</span>
          <div class="tip">开启跟读练习功能，边听边读</div>
        </a>
        <a class="btn btn-def btn-write btn-tip" :class="{'btn-act': showSign}" @click.stop="articleState(4)" v-if="getKnowledgeSigns.length">
          <i class="icon"></i>
          <span>朗读指导</span>
          <!-- <div class="tip">开启背诵默写功能，隐藏课文文案</div> -->
        </a>
        <!-- <a class="btn btn-def btn-write btn-tip" :class="{'btn-act': audioTypes[key].isWrite}" @click.stop="articleState(2)">
          <i class="icon"></i>
          <span>背诵默写</span>
          <div class="tip">开启背诵默写功能，隐藏课文文案</div>
        </a> -->
        <div class="menuSwitch flex-center" v-if="!getMenuWay" @click.stop="openMenu">
          <p class="iconfont xiala1" :class="{'rotate-close': !showBottom, 'rotate-open': showBottom}"></p>
          <p>{{showBottom ? '收起菜单' : '展开菜单'}}</p>
        </div>
      </div>
      <div class="right-btns" v-if="key=='word'">
        <a v-if="audioStates[key]" :class="{'btn-act':  curWordState.isFollow}" class="btn btn-def btn-follow btn-tip" @click.stop="changeWordState(2)">
          <i class="icon"></i>
          <span>跟读练习</span>
          <div class="tip">开启跟读练习功能，边听边读</div>
        </a>
        <!-- <a class="btn btn-def btn-write btn-tip" @click.stop="changeWordState(3)" :class="{'btn-act':  curWordState.isWrite}">
          <i class="icon"></i>
          <span>背诵默写</span>
          <div class="tip">开启背诵默写功能，隐藏生字生词文案</div>
        </a> -->
        <div class="menuSwitch flex-center" v-if="!getMenuWay" @click.stop="openMenu" >
          <p class="iconfont xiala1" :class="{'rotate-close': !showBottom, 'rotate-open': showBottom}"></p>
          <p>{{showBottom ? '收起菜单' : '展开菜单'}}</p>
        </div>
      </div>
    </div>
    <transition name="left-slide">
      <div class="list-box" v-if="isHasCourse && showList">
        <div class="title">
          <span class="line1">目录 <i>{{ info.book?.name || '' }}</i></span>
          <a @click.stop="toWare()"><span>其它书籍</span><i class="icon icon-right" /></a>
        </div>
        <div class="con">
          <div class="course-list" ref="courseList" :style="getMaxHeightStyle">
            <dl :id="'courseItem_'+course.id" :class="{'actived': selectCourseItem.id == course.id}" v-for="(course,i) in courseList" :key="i" @click.stop="toLisiter(course)">
              <dt>
                <img :src="course.thumbnailUrl">
                <!-- <div class="mask"></div> -->
                <!-- <i class="icon icon-play-w v-align" :class="{'icon-playing' : audioStates[key].isPlay && selectCourseItem.id == course.id}"></i> -->
              </dt>
              <dd>
                <div class="left">
                  <div class="audio-box37" v-if="selectCourseItem.id == course.id && audioStates[key].isPlay">
                    <div class="audio37-block" v-for="i in 3" :key="i"></div>
                  </div>
                  <div class="sub-title" v-text="course.name"></div>
                </div>
                <!-- <a class="ting" v-if="selectCourseItem.id == course.id && audioStates[key].isPlay">播放中</a>
                <i class="icon icon-right" v-else></i> -->
                <button  class="btn flex-center">{{selectCourseItem.id == course.id ? '当前选择':'选择'}}</button>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </transition>
    <div class="gif-box" @click.stop="closeGif" v-if="gifObj">
      <div class="word">
        <img :src="gifObj.gifUrl">
      </div>
    </div>
    <BuyBook ref="buyBook" />
    <Record ref="recordRef" @openReport="openReport"/>
    <ReportAnalysis ref="reportRef" />
  </div>
</template>
<script>
import {
  mapGetters,
  mapActions
} from 'vuex';

import util from 'libs/util'
import Vue from 'vue'
import AudioManager from 'business/AudioManager'
import TimingManager from 'libs/TimingManager';
import ProgressBar from 'business/ProgressBar';
import BuyBook from 'business/BuyBook';
import WordRow from 'business/WordRow';
import Flower from 'business/Flower';
import CountUp from 'base/ydcountup';
import helpers from 'dom-helpers';
// import AssignWork from 'pages/book/assignWork';
// import ReportList from 'pages/book/reportList';
import Annotation from './annotation.vue'
import Rate from './rate.vue'
// import ReportDetails from './reportDetails'
import Details from 'pages/course/afterClass/details'
import ExamList from 'pages/course/afterClass/examList'
import Record from './record.vue';
import ReportAnalysis from './reportAnalysis'
import { Switch } from "element-ui";

const WORDTYPES = [{
  id: 1,
  name: '识字',
  key: 'literacy',
  list: [],
  type: 1
}, {
  id: 2,
  name: '写字',
  key: 'word',
  list: [],
  type: 1
}, {
  id: 3,
  name: '词语',
  key: 'words',
  list: [],
  type: 2
}, {
  id: 4,
  name: '识字加油站',
  key: 'literacyGasStation',
  list: [],
  type: 2
}]

let clickTimer = null;

export default {
  components: {
    AudioManager,
    ProgressBar,
    WordRow,
    BuyBook,
    Flower,
    CountUp,
    Rate,
    'el-switch': Switch,
    // AssignWork,
    // ReportList,
    Annotation,
    // ReportDetails,
    Details,
    ExamList,
    Record,
    ReportAnalysis
  },
  computed: {
    ...mapGetters([
      'getClientHeight',
      'getUserInfo',
      'getStatInfo',
      'getIsFlexCenter',
      'getKnowledgeSettings',
      "getKnowledgeSigns",
      "getKnowledgeStatus",
      "getMenuWay",
    ]),
    getMinHeightStyle() {
      return {
        minHeight: `${this.getClientHeight-140}px`
      }
    },
    getMaxHeightStyle() {
      return {
        maxHeight: `${this.getClientHeight-280}px`
      }
    },
    key() {
      this.showSign = false;
      if (this.selectItem.id == 1) {
        return 'article';
      }
      if (this.selectItem.id == 2) {
        return 'guidance';
      }
      if (this.selectItem.id == 3) {
        return 'word';
      }
    },
    bgStyles() {
      let info = this.info;
      if (info.pcBgimgUrl) {
        return {
          backgroundImage: `url(${info.pcBgimgUrl})`
        }
      }
      return ''
    },
    manage() {
      return this.$refs[`${this.key}_manage`];
    },
    loopModeTxt() {
      if (this.key != 'word') {
        return {
          1: '单章播放',
          2: '单章循环',
          3: '顺序播放'
        } [this.loopMode]
      } else {
        return {
          1: '单字播放',
          2: '单字循环',
          3: '顺序播放'
        } [this.loopMode]
      }
    },
    getKind() {
      let kind = -1;
      let info = this.info;
      if (info && info.book && info.article) {
        if (info.book.kind == 2 || !info.article.contents) {
          kind = 2;
        } else {
          kind = 1;
        }
      }
      return kind
    },
  },
  data() {
    return {
      posNavs: [],
      wordNavList: [],
      courseKinds: [],
      loaded: 0,
      loopMode: 1,
      actType: 1,
      currentTime: 0,
      duration: 0,
      gifObj: null,
      isHasCourse: 0,
      showList: 0,
      isHasTime: 0,
      clientHeight: util.getViewHeight(),
      selectCourseItem: {},
      showLoop: true,
      selectItem: {
        id: 1,
        showFooter: 1
      },
      selectedWordTypeItem: {
        id: -1
      },
      navList: [],
      info: {
        book: {},
      },
      audioTypes: {
        article: {},
        guidance: {}
      },
      disableOpts: {
        preDisabled: true,
        nextDisabled: false
      },
      curWordState: {
        isWrite: false,
        isFollow: false,
        index: 0,
        id: -1
      },
      guidance: {
        hasTxt: false,
        txt: '好好学习<em class="em">天天向上</em>',
        curRow: {}
      },
      audioStates: {
        article: {
          isPlay: false,
          playMode: 'auto'
        },
        guidance: {
          isPlay: false,
          playMode: 'auto'
        },
        word: {
          isPlay: false,
          playMode: 'auto'
        }
      },
      partSelectItem: {
        id: -1
      },
      wordTypes: WORDTYPES,
      wordAudioList: [],
      wordAudioOptions: {},
      codeImg: '',
      isOrga: false,
      showSign: false,
      showReportDetail: false,
      homeworkId: null,
      isShowAssign: false, // 布置作业弹窗
      classesId: '', // 布置作业切换的扳机id
      showBottom: false,
      isShowTab: false, // 底部菜单展开按钮
      tapRead: {
        status: false,
        isAuto: true,
        key: ''//'ai'
      }
    }
  },
  mounted() {
    this.$store.commit("setIsCourseMenu", true)
    sessionStorage.removeItem("audioRate")
    const query = this.$route.query;
    this.courseCacheData = {};
    this.loaded = 0;
    this.id = query.id;
    this.init();
     if (util.getStorage('orgaId')) {
        this.isOrga = true
        this.checkedOrga()
    }
  },
  methods: {
    openMenu() {
      this.$refs.headRef && this.$refs.headRef.coursePageMenuStatus();
    },
    // 布置作业sure
    sureAssign(id) {
      this.isShowAssign = false;
      if (this.selectItem.id == 7 && !this.showReportDetail) this.classesId = id;
    },
    openReport() {
      this.$refs.reportRef.showReport();
    },
    // 查看报告详情
    checkDetails(id) {
      this.showReportDetail = true;
      this.homeworkId = id;
    },
    // 查找机构信息
    checkedOrga () {
      let url = `/passport/orgainfo.json`
      this.$post(url, {}).then((res) => {
        this.codeImg = res.data.llssMpQrCodeUrl
      }).catch((e) => {
        console.log(e)
      })
    },
    async init() {
      this.$loading.show();
      let info = await this.getCourseInfo();
      this.info = info;
      console.log('----info-=---',this.info);
      this.kind = info.book.kind;
      this.initPageData();
      this.getCourseList();
      this.$nextTick(() => {
        this.loaded = 1;
        this.$loading.hide();
      })
    },
    async getCourseList() {
      let book = this.info.book;
      const params = {
        bookId: book.id
      }
      let courseList = [];
      const res = await this.$post('/book/info.json', params);
      if (res.status == 200) {
        let data = res.data || {};
        let count = 0;
        data = this.$getBookImg(data);
        const courseKinds = data.courseKinds || [];
        courseKinds.forEach((item) => {
          if (item.courseList) {
            item.courseList.forEach((c) => {
              this.isHasCourse = true;
              c = this.$getCourseImg(c);
              courseList.push(c);
            })
          }
        });
        if (courseList.length < 1) {
          this.isHasCourse = false;
        }
        this.courseList = courseList;
      }
    },
    setPosNav() {
      let info = this.info;
      let book = info.book;
      let query = this.$route.query;
      let posNavs = [{
        id: 1,
        name: '首页',
        pathName: 'index'
      }];
      if (query.fromType == 2) {
        posNavs.push({
          id: 2,
          name: '诵读资源',
          pathName: 'book_library'
        })
      }
      posNavs.push({
        id: 3,
        name: book.name,
        pathName: 'book_detail',
        callback: () => {
          this.$gopage('book_detail', {
            id: book.id,
            type: query.fromType
          })
        }
      })
      posNavs.push({
        id: 4,
        name: info.name
      })
      this.posNavs = posNavs;
      if (book && book.gradeSettingId) {
        util.setStorage('lastClickBookLabelId', book.gradeSettingId)
      }
    },
    initAudioManager() {
      Object.keys(this.audioTypes).forEach((key, i) => {
        let options = this.getAudioOptions(key);
        this.audioTypes[key] = options;
      });
    },
    initPageData() {
      this.posNavs = [];
      this.wordNavList = []
      this.wordAudioList = [];
      this.selectedWordTypeItem = {
        id: -1
      }
      this.curWordState.id = -1;
      this.initAudioManager();
      this.checkPageType();
      this.createArticleTask();
      this.initWordAudioTask();
      this.setPosNav();
      this.$store.dispatch('queryUserInfo');
    },
    getAudioOptions(key) {
      let info = this.info || {};
      let audioData = info[key] || {};
      if (audioData) {
        let { voiceUrl, contents } = audioData;
        let artTxts = '';
        if (key == 'guidance') {
          if (info.skills && info.skills.contents) {
            artTxts = info.skills.contents
          } else {
            artTxts = info['article']?.contents || '';
          }
        }
        let options = {
          src: voiceUrl,
          artTxts,
          txts: contents || '',
          title: info.name,
          stopTime: info.stopTime,
          courseId: this.id,
          skills: info.skills,
          canClickRow: false,
          isWrite: false,
          onPlay: () => {
            this.audioStates[this.key].isPlay = true;
            this.playStatus = 1;
          },
          onChangeState: (isPlay) => {
            if (this.audioStates[this.key]) {
              this.audioStates[this.key].isPlay = isPlay;
            }
          },
          onEnded: (type) => {
            if (this.partSelectItem.id < 0) {
              this.playStatus = 2;
              if (this.loopMode == 2) {
                this.manage.replay();
              } else {
                this.timeingManager.modeType = this.loopMode;
                this.timeingManager.callNext();
              }
            }
          },
          onFollowStop: () => {
            console.log('Flowerstop:' + this.loopMode)
            this.playStatus = 2;
            if (this.loopMode == 2) {
              this.manage.replay();
            } else {
              this.timeingManager.callNext();
            }
          },
          onStop: (type) => {
            this.playStatus = 2;
          },
          onPause: () => {
            this.playStatus = 0;
          },
          onReady: (duration) => {
            this.duration = duration
          },
          onTimeUpdate: (currentTime) => {
            this.currentTime = currentTime
          },
          onLineUpdate: ({ displayLine, txt }) => {
            if (txt != '-' && txt) {
              this.guidance.hasTxt = true;
              this.guidance.curRow = displayLine;
            } else {
              this.guidance.hasTxt = false;
            }
          },
          onLiricReady: ({ wordPageStyle, isHasTime }) => {
            this.isHasTime = isHasTime;
            if (this.key == 'guidance') {
              this.guidance.wordPageStyle = wordPageStyle;
            }
          },
          onModeChange: (mode) => {
            if (this.audioStates[this.key]) {
              this.audioStates[this.key].playMode = mode;
            }
          }
        }
        return options;
      }
    },
    articleWrite() {
      let key = this.key;
      this.manage && this.manage.stop();
      this.audioTypes[key].isWrite = !this.audioTypes[key].isWrite;
    },
    toWare() {
      let info = this.info;
      this.$gopage('book_ware', {
        id: info.book.id
      })
    },
    onRowClickHandle(result) {
      if (this.showList) {
        return;
      }
      console.log('----------------单点')
      this.checkAuth(() => {
        this.showList = false;
        this.manage && this.manage.clickSingleRow(result, this.tapRead);
      });
    },
    onPartItemClick(item) {
      let key = this.key
      this.partSelectItem = item;
      if (key == 'article') {
        this.showLoop = item.id > 0 ? false : true
      }
    },
    isMorning() {
      let d = new Date();
      let hour = d.getHours();
      let day = d.getDay();
      let morning = '';
      if (day && day != 6) {
        if (hour >= 7 && hour < 9) {
          return true
        }
      }
      return false;
    },
    /**
     * [checkPageType 检查页面类型]
     * @return {[type]}      [description]
     */
    checkPageType() {
      let data = this.info;
      let wordAudioList = [];
      let navList = [];
      let wordNavList = [];
      if (this.getKind != 2) {
        let showTab = false;
        // 有文章显示文章
        if (data.article) {
          navList.push({
            id: 1,
            name: this.$route.query.fromType == 2 ? '示范朗读' : '朗读教学',
            icon: 'langdujiaoxue-xuanzhong',
            showFooter: 1
          })
        }
        // 是否有朗读指导
        // if (data.guidance) {
        //   navList.push({
        //     id: 2,
        //     name: '朗读指导',
        //     showFooter: 1,
        //     showHot: true
        //   })
        // }
        let cnt = 0;
        // 是否有生字词
        WORDTYPES.forEach((n) => {
          let key = n.key;
          const listData = data[key] || [];
          listData.forEach((n) => {
            n.index = cnt;
            cnt++;
          });
          n.list = this.parseWords(listData, n.type);
          if (n.list && n.list.length) {
            wordNavList.push(n);
          }
        });
        this.wordAudioList.forEach((item, i) => {
          item.index = i;
        })
        wordNavList.unshift({
          id: -1,
          name: '全部',
          list: []
        });
        this.wordNavList = wordNavList;
        if (cnt > 0) {
          navList.push({
            id: 3,
            name: '识字写字',
            icon: 'shizixiezi-moren',
            showFooter: 1
          })
        }
        // if (data.teachingTarget) {
        //   navList.push({
        //     id: 4,
        //     name: '教学目标',
        //     showFooter: 0
        //   });
        // }
         navList.push(
        //   {
        //   id: 5,
        //   name: '朗读作业',
        //   showFooter: 0
        // }, 
        // {
        //   id: 6,
        //   name: '布置练习',
        //     icon: 'buzhilianxi-moren',
        // }, 
        {
          id: 7,
          name: '练习报告',
          icon: 'lianxibaogao-moren',
        })
        this.navList = navList;
      }
    },
    parseWords(list, type) {
      let wordAudioList = [];
      list.forEach((item, i) => {
        if (item.contents) {
          const rs = this.transformWord(item.contents);
          if (rs && rs.length == 1 && type == 1) {
            item.wordItem = rs[0];
          } else {
            item.list = rs;
          }
          item.isWrite = true;
          wordAudioList.push({
            id: item.id,
            voiceUrl: item.voiceUrl
          });
        }
      });
      this.wordAudioList = this.wordAudioList.concat(wordAudioList);
      return list;
    },
    transformWord(words) {
      const arr = words.split(')');
      const newArr = [];
      arr.forEach((str) => {
        if (str.length == 1) {
          newArr.push({
            zh: str,
            py: ''
          })
        } else {
          const reg = /(.*)\(+(.*)/g;
          const matchs = reg.exec(str);
          if (matchs && matchs.length > 2) {
            const item = {
              zh: matchs[1],
              py: matchs[2]
            }
            newArr.push(item);
          }
        }
      });
      return newArr;
    },
    rightNavItemClick(item) {
      this.selectedWordTypeItem = item;
      this.manage.stop();
      this.audioStates[this.key].isPlay = false;
      let list = [];
      if (item.id != -1) {
        this.wordTypes = [item];
        this.wordTiming.setList(item.list)
      } else {
        this.wordTypes = WORDTYPES;
        this.wordTiming.setList(this.wordAudioList)
      }
      this.curWordState.id = -1;
      this.curWordState.index = 0;
      this.partSelectItem = { id: -1 }
      this.$nextTick(() => {
        this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(0, true)
      })
    },
    initWordAudioTask() {
      this.wordTiming = new TimingManager({
        taskList: this.wordAudioList,
        modeType: 3,
        onCall: (item) => {
          this.playWordAudio(item)
        }
      });
      const callNext = () => {
        console.log('------------------xiayishou',this.isClickPlay)
        if (this.isClickPlay) {
          this.isClickPlay = false;
          this.audioStates[this.key].isPlay = false;
          this.curWordState.index = 0;
          return
        }
        let selectedWordTypeItem = this.selectedWordTypeItem;
        let curWordState = this.curWordState;
        this.wordTiming && this.wordTiming.callNext()
      }
      this.curWordState.index = 0;
      this.wordAudioOptions = {
        onReady: (duration) => {
          this.duration = duration
        },
        onTimeUpdate: (currentTime) => {
          this.currentTime = currentTime
        },
        onStop: () => {
          this.curWordState.index = 0;
        },
        onEnded: () => {
          if (this.audioStates[this.key].isPlay) {
            if (this.curWordState.isFollow) {
              this.callNextWordTimer = setTimeout(() => {
                callNext();
              }, 5000)
            } else {
              callNext();
            }
          } else {
            this.audioStates[this.key].isPlay = false;
            clearTimeout(this.callNextWordTimer);
          }
        }
      }
    },
    playWordAudio(item) {
      if (item) {
        let { voiceUrl, index } = item;
        this.curWordState = {
          ...this.curWordState,
          index,
          id: item.id
        }
        if (this.curWordState.isOrdering) {
          // this.curWordState.scrollId = 'word_' + item.id
        }
        if (this.manage) {
          this.manage.stop();
          this.manage.setOptions({
            src: voiceUrl,
            autoplay: true
          })
        }
      }
    },
    playWord(item, index) {
      this.manage.stop();
      this.isClickPlay = true;
      this.audioStates[this.key].isPlay = true;
      this.curWordState.isFollow = false;
      if (this.selectedWordTypeItem.id != -1) {
        this.wordTiming && this.wordTiming.callIndex(index);
      } else {
        this.wordTiming && this.wordTiming.callIndex(item.index);
      }
    },
    async playClickWord(item, index = 0) {
      clearTimeout(clickTimer)
      console.log('---------222-click',index)
      clickTimer = setTimeout(() => {
        this.checkAuth(() => {
          this.playWord(item, index)
        })
      }, 300);
    },
    showWordGif(item, index = 0,wIdx = 0) {
      clearTimeout(clickTimer);
      this.checkAuth(() => {
        console.log('----------click',item.gifUrlList)
        this.playWord(item, index);
        if (item.gifUrlList && item.gifUrlList.length > wIdx) {
          this.gifObj = {
            gifUrl: item.gifUrlList[wIdx]
          };
        }
      })
    },
    closeGif() {
      this.gifObj = null;
    },
    changeWordState(type) {
      const func = () => {
        let key = this.key
        if (type == 1) {
          this.audioStates[key].isPlay = !this.audioStates[key].isPlay;
          if (this.audioStates[key].isPlay) {
            this.wordTiming && this.wordTiming.start(this.curWordState.index, true);
          } else {
            this.manage && this.manage.stop();
            clearTimeout(this.callNextWordTimer);
          }
        }
        let id = -1;
        if (type == 2) {
          this.curWordState.id = id;
          this.curWordState.index = 0;
          this.audioStates[key].isPlay = false;
          clearTimeout(this.callNextWordTimer)
          this.manage && this.manage.stop();
          this.curWordState.isFollow = !this.curWordState.isFollow;
        }
        if (type == 3) {
          this.manage && this.manage.stop();
          clearTimeout(this.callNextWordTimer)
          this.audioStates[key].isPlay = false;
          this.curWordState.index = 0;
          this.curWordState.id = id;
          this.curWordState.isWrite = !this.curWordState.isWrite;
        }
      }
      this.checkAuth(() => {
        func();
      })
    },
    getCourseInfo(id) {
      return new Promise(async (resolve, reject) => {
        let reaId = id || this.id;
        this.$store.commit("setCurKnowledge",{})
        const res = await this.$post('/course/info.json', {
          courseId: reaId
        });
        this.selectCourseItem.id = reaId;
        if (res.status == 200 && res.data) {
          let data = res.data;
          data = this.$getCourseInfo(data);
          if (!this.courseCacheData[id]) {
            this.courseCacheData[id] = data;
          }
          resolve && resolve(data);
        }
      })
    },
    openRecord() {
      if(this.audioStates[this.key].isPlay)this.togglePlay()
      this.$refs.recordRef.openDrawer(this.audioTypes?.guidance?.artTxts);
    },
    changeMode(status) {
      this.tapRead.status = status;
    },
    onClickMode(key) {
      const isSelect = this.audioTypes[this.key].canClickRow;
      const isSame = isSelect && this.tapRead.key === key;
      if(!isSelect || isSame)this.articleState(3);
      this.tapRead = {
        ...this.tapRead,
        key: isSame ? '' : key,
        status: false
      };
    },
    articleState(type) {
      // this.checkAuth(() => {
        if (this.manage && this.audioTypes[this.key]) {
          if(type != 3 && this.tapRead.key) {
            this.tapRead = {
              ...this.tapRead,
              key: '',
              status: false
            };
          }
          // 三个按钮状态需要互斥
          if (type == 1 || (type != 1 && this.audioStates.article.playMode=='follow')) {
            this.manage.switchMode();
          }

          if (type == 2) {
            this.articleWrite();
          }

          if (type == 3 || (type != 3 && this.audioTypes.article.canClickRow)) {
            this.manage && this.manage.stop();
            this.audioTypes[this.key].canClickRow = !this.audioTypes[this.key].canClickRow
            this.tapRead.status = this.audioTypes[this.key].canClickRow;
          }

          if (type == 4) {
            this.changeStatus();
          } else {
            this.showSign = false;
            this.$store.commit("setKnowledgeSettings", {
              ...this.getKnowledgeSettings,
              isOpen: false,
            });
          }
        }
      // })
    },
    navItemClick(item) {
      if (this.manage) {
        this.manage.pause(true);
      }
      this.manage && this.manage.reset();
      this.manage && this.manage.resetPart();
      this.classesId = '';
      this.$store.commit("setIsCourseMenu", true);
      if (item.id === 7) this.$store.commit("setIsCourseMenu", false);
      if (item.id === 6) {
        this.isShowAssign = true;
        return
      }
      if (this.audioTypes[this.key]) {
        this.audioTypes[this.key].isWrite = false;
      }
      this.timeingManager && this.timeingManager.setMode(this.loopMode);
      this.isShowAssign = false;
      this.showReportDetail = false;
      this.selectItem = item;
    },
    checkAuth(callback, jType = 2, toNext = false) {
      const info = this.info;
      const book = info.book;
      const pcFreeFlag = info.pcFreeFlag;
      this.$user.checkIsLogin(() => {
        if (util.getStorage('orgaId')) {
          callback && callback();
          return
        }
        if (pcFreeFlag == 1) {
          callback && callback(); // 免费的 或者是 专题
        } else {
          if (this.getUserInfo.memberFlag) {
            callback && callback(); // 已经购买
          } else {
            this.$confirm(`您还不是会员，是否前去兑换？`, {
              onOk: async () => {
                this.$refs.buyBook.open();
                // this.$eventBus.$once('buyCallback', () => {
                // callback && callback();
                // })
              }
            })
          }
        }
      }, jType, toNext)
    },
    async refCourse() {
      let info = await this.getCourseInfo();
      this.info = info;
    },
    async switchCourse(type) {
      this.showList = false;
      if (this.manage) {
        if (type == 1) {
          if (this.disableOpts.preDisabled) {
            return;
          }
          this.manage.stop();
          this.timeingManager.pre();
        } else {
          if (this.disableOpts.nextDisabled) {
            return;
          }
          this.manage.stop();
          this.timeingManager.next();
        }
        if(this.tapRead.key) this.onClickMode(this.tapRead.key)
      }
    },
    async callNextCourse(id,isNext) {
      console.log('-----------222',id)
      this.id = id;
      let info = this.courseCacheData[id];
      this.$loading.show();
      this.manage && this.manage.stop();
      this.curWordState.isPlay = false;
      this.audioStates[this.key].isPlay = false;
      if (this.audioTypes[this.key]) {
        this.audioTypes[this.key].isWrite = false;
      }
      this.wordTypes = WORDTYPES;
      this.curWordState.index = 0;
      clearTimeout(this.callNextWordTimer);
      if (!info) {
        info = await this.getCourseInfo(id);
      }
      this.info = info;
      this.manage.switchMode('auto', true);
      this.initPageData()
      this.$nextTick(() => {
        this.$loading.hide();
        this.manage && this.manage.reset();
        this.$refs.scrollbar && this.$refs.scrollbar.scrollToY(0, true);
        setTimeout(() => {
          if(isNext&&this.loopMode === 3) this.manage && this.manage.toggle();
        },300)
      });
      // this.$gopage('book_course', { id })
    },
    openList() {
      this.showList = !this.showList;
      if (this.showList) {
        this.$nextTick(() => {
          let id = this.id;
          let target = document.querySelector('#courseItem_' + id)
          if (target) {
            this.$refs.courseList.scrollTop = target.offsetTop - 66;
          }
        })
      }
    },
    toLisiter(item) {
      this.manage && this.manage.stop();
      this.checkAuth(() => {
        this.callNextCourse(item.id);
        this.selectCourseItem = item;
        this.showList = false;
      })
    },
    setLoopMode() {
      let loopMode = this.loopMode;
      if (loopMode == 3) {
        loopMode = 1;
      } else if (loopMode == 1) {
        loopMode = 2;
      } else {
        loopMode = 3;
      }
      this.loopMode = loopMode;
      this.timeingManager && this.timeingManager.setMode(loopMode);
    },
    togglePlay(noCheck) {
      const func = () => {
        if (this.manage) {
          if (this.key != 'word') {
            this.manage && this.manage.toggle();
          } else {
            this.changeWordState(1);
          }
        }
      }
      this.checkAuth(() => {
        func()
      })
    },
    createArticleTask() {
      let info = this.info;
      let bookCourseIds = info.bookCourseIds;
      let taskOptions = {};
      if (bookCourseIds && bookCourseIds.length > 0) {
        taskOptions = {
          taskList: bookCourseIds,
          modeType: 1,
          initId: this.id,
          onCall: (item, index, disableOpts) => {
            this.disableOpts = disableOpts;
            this.callNextCourse(item,true);
          }
        }
        this.timeingManager = new TimingManager(taskOptions);
        this.timeingManager.setIndexById(info.id);
        this.disableOpts = this.timeingManager.getDisableOptsById(info.id);
        this.timeingManager.start();
      }
    },
    touchend(s, per) {
      this.checkAuth(() => {
        if (this.manage) {
          this.manage.seekOrLine(s);
        }
      })
    },
    changeStatus() {
      this.showSign = !this.showSign;
      this.$store.commit('setKnowledgeStatus',true) //Switch知识点的优先级最高
    },
    dishPlay() {
      if(this.$refs.article_manage._isPlaying)this.$refs.article_manage.toggle()
    }
  },
  beforeDestroy() {
    this.$store.commit("setGlobalAudioRate", 1);
    this.$store.commit("setIsCourseMenu", false);
  }
}
</script>
<style lang="less" scoped>
@import '~styles/book/course.less';


</style>